function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput, Saturation, Hue } from 'react-color/lib/components/common';
import { FieldLabel } from "../";

import color from 'react-color/lib/helpers/color';

import "./ColorpickerInput.scss";

var ColorSwatch = function (_Component) {
    _inherits(ColorSwatch, _Component);

    function ColorSwatch() {
        var _temp, _this, _ret;

        _classCallCheck(this, ColorSwatch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (data, e) {
            var _this$props = _this.props,
                hex = _this$props.hex,
                rgb = _this$props.rgb,
                hsl = _this$props.hsl,
                hsv = _this$props.hsv;


            if (data['hex']) {
                color.isValidHex(data['hex']) && _this.props.onChange({
                    hex: data['hex'],
                    source: 'hex'
                }, e);
            } else if (data.r || data.g || data.b) {
                _this.props.onChange({
                    r: data.r || rgb.r,
                    g: data.g || rgb.g,
                    b: data.b || rgb.b,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.v) {
                _this.props.onChange({
                    h: data.h || hsv.h,
                    s: data.s || hsv.s,
                    v: data.v || hsv.v,
                    source: 'hsv'
                }, e);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ColorSwatch.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            hex = _props.hex,
            rgb = _props.rgb,
            hsl = _props.hsl,
            hsv = _props.hsv;


        return React.createElement(
            'div',
            { className: 'admin-colorpicker__input' },
            React.createElement(
                'div',
                { className: 'admin-field  field--input  field--hex' },
                React.createElement(EditableInput, { hideLabel: true, label: 'hex', placeholder: 'HEX', value: hex, onChange: this.onChange })
            ),
            React.createElement(
                'div',
                { className: 'admin-field  field--input  field--rgb' },
                React.createElement(
                    'div',
                    { className: 'r' },
                    React.createElement(EditableInput, { hideLabel: true, label: 'r', value: rgb.r, onChange: this.onChange })
                ),
                React.createElement(
                    'div',
                    { className: 'g' },
                    React.createElement(EditableInput, { hideLabel: true, label: 'g', value: rgb.g, onChange: this.onChange })
                ),
                React.createElement(
                    'div',
                    { className: 'b' },
                    React.createElement(EditableInput, { hideLabel: true, label: 'b', value: rgb.b, onChange: this.onChange })
                )
            )
        );
    };

    return ColorSwatch;
}(Component);

export default CustomPicker(ColorSwatch);